import { createSlice } from "@reduxjs/toolkit";
import { createIndependentStore } from "@utils/react";
var slice = createSlice({
	name: "provider/user-identity",
	initialState: { user: void 0 },
	reducers: { setUser(state, action) {
		state.user = action.payload;
	} }
});
var userIdentityStore = createIndependentStore(slice);
var getUserIdentityState = userIdentityStore.getState;
var useUserIdentityState = userIdentityStore.useSelector;
//#endregion
export { getUserIdentityState, slice, useUserIdentityState, userIdentityStore };

//# sourceMappingURL=user-identity.state.js.map